// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PdpBadges_wrapper__yy2lh","badges":"PdpBadges_badges__29Zed"};